import PropTypes from "prop-types";
import { Outlet } from "react-router-dom";

import PageLayout from "./PageLayout";
import MDBox from "../materialDashboard/components/MDBox";

import {Grid} from "@mui/material";

// Images
import bgImage from "assets/images/auth-bg.jpg";
import LanguageSelector from "./LanguageMenu";


const AuthLayout = ({image = bgImage}) => {
    return (
        <PageLayout>
            <MDBox
                position="absolute"
                width="100%"
                minHeight="100vh"
                sx={{
                    backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
                        image &&
                        `${linearGradient(
                            rgba(gradients.dark.main, 0.5),
                            rgba(gradients.dark.state, 0.5)
                        )}, url(${image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                }}
            />
            <MDBox px={1} width="100%" height="100vh" mx="auto">
                <MDBox color="white" textAlign="right">
                    <LanguageSelector />
                </MDBox>
                <Grid container spacing={1} justifyContent="center" alignItems="center" height="100%">
                    <Grid item xs={11} sm={9} md={5} lg={4} xl={3}>
                        <Outlet/>
                    </Grid>
                </Grid>
            </MDBox>
        </PageLayout>
    );
}

// Typechecking props for the BasicLayout
AuthLayout.propTypes = {
    image: PropTypes.string,
};

export default AuthLayout;